import api from '@/api';
import * as types from './mutation-types';

export default {
    // 활성 메인 팝업 목록 조회 (언어 포함)
    fetchMainPopupList({ commit }, lang) {
        // lang: 'ko' | 'en'  ← HomePage에서 넘겨줌
        return api.get('/MainPopups', {
            params: { lang },   // ★ 여기서 언어 전달
        })
            .then(res => {
                const list = res.data?.data || [];
                commit(types.FETCH_MAINPOPUP_LIST, list);
            })
            .catch(err => {
                console.error('📛 메인 팝업 목록 조회 오류:', err);
                commit(types.FETCH_MAINPOPUP_LIST, []);
            });
    },
};
